import {colord} from 'colord';

import {Nullish} from 'shared/web';

import {getUserColor} from './getUserColor';

const LOW_PRIORITY_LIGHTEN_AMOUNT = 0.08;
const HIGH_PRIORITY_DARKEN_AMOUNT = 0.2;

/**
 * Per-priority shades of a user's calendar color: the user color identifies the person,
 * its lightness identifies the task priority (LOW lightest, MEDIUM base, HIGH darkest).
 */
export function getUserColorVariants(userIndex: number | Nullish): Record<string, string> {
  const color = getUserColor(userIndex);

  return {
    HIGH: colord(color).darken(HIGH_PRIORITY_DARKEN_AMOUNT).toHex(),
    MEDIUM: color,
    LOW: colord(color).lighten(LOW_PRIORITY_LIGHTEN_AMOUNT).toHex(),
    USER: color,
  };
}
